/** Staff removal. The id stays recorded so a local seed does not come back. */
export function removeFromRoster<T extends { id: string }>(
  students: readonly T[],
  removedIds: readonly string[],
  id: string,
): { students: T[]; removedIds: string[] } {
  return {
    students: students.filter((student) => student.id !== id),
    removedIds: removedIds.includes(id) ? [...removedIds] : [...removedIds, id],
  };
}

/** Local seeds fill gaps. A removed id is a gap that stays empty. */
export function mergeRosterSeeds<T extends { id: string }>(
  current: readonly T[],
  seeds: readonly T[],
  removedIds: readonly string[],
): T[] {
  const ids = new Set<string>();
  current.forEach((student) => ids.add(student.id));
  removedIds.forEach((id) => ids.add(id));
  const extras = seeds.filter((student) => !ids.has(student.id));
  if (extras.length === 0) return current as T[];
  return [...current, ...extras];
}

/** Drop one student's rows and leave everyone else. */
export function omitStudentId<T extends { studentId: string }>(
  rows: readonly T[],
  studentId: string,
): T[] {
  return rows.filter((row) => row.studentId !== studentId);
}
